export const PageText = {
  _1: 'Why health-based?',
  _2: 'This aircheckr AQI is completely health-based and hence independent of politically set thresholds.'
};

export const Categories = {
  _1: {
    title: 'Independent',
    subcategories: [
      {
        key: 0,
        subtitle: 'More honest',
        text: 'In general the threshold set by the governments are less stringent than those set by the WHO, that are purely health-based. This is so, because governments do not only consider your health, but also economic parameters. Moreover, governmental decisions are not always insensitive for lobbying activities.'
      },
      {
        key: 1,
        subtitle: 'Research based',
        text: 'This aircheckr AQI is independent of politically set thresholds. It is based on the result of an intensive research on the health effects of the four aircheckr pollutants executed by the ‘National Institute for Public Health and the Environment’ in The Netherlands.'
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/help-and-guides/why-health-based_page.js